import React, { ReactElement, useState, useMemo } from 'react';
import Image from 'next/image';
import styled, { css } from 'styled-components';

import theme, { bp, color } from 'settings/theme';
import { stake, unstake } from '@cardinal/rewards-center';
import { PublicKey, Transaction } from '@solana/web3.js';
import toast from 'react-hot-toast';
import { useWallet, useConnection } from '@solana/wallet-adapter-react';
import { getAssociatedTokenAddressSync, createAssociatedTokenAccountInstruction } from '@solana/spl-token';


type Props = {
  nft: Nft;
  collectionFilter: string;
  fetchNFTs: () => void;
};

const StakingCard: React.FC<Props> = (props) => {

  const wallet = useWallet();
  const { connection } = useConnection();
  const gobiAddress = new PublicKey("MarcoPaG4dV4qit3ZPGPFm4qt4KKNBKvAsm2rPGNF72");

  const handleStakeSingle = async () => {
    try {
      // const selectedCollectionNFTs = validNFTHeld.filter((nft) => nft.collectionAddress === collectionFilter && nft.isSelected && !nft.isCurrentlyStaked);
      // const selectedNFTs = (selectedCollectionNFTs.length > 0 ? selectedCollectionNFTs : validNFTHeld.filter((nft) => nft.collectionAddress === collectionFilter)).map((nft) => {
      //   return {
      //     ...nft,
      //     isSelected: true
      //   }
      // });
      toast.success("Generating Stake Transactions", {
        id: "stake",
        duration: Infinity
      })
      // console.log("selectedNFTs", selectedNFTs

      let stakeSelected = await stake(
        connection,
        wallet,
        props.collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? "pool-name-0.1908876937934032" : "pool-name-0.7364440881038641",
        [{ mintId: new PublicKey(props.nft.mintAddress) }],
      )
      // console.log("stakeSelected", stakeSelected)


      const { blockhash } = await connection.getLatestBlockhash();
      const datedStakeSelected = stakeSelected.map((tx) => {
        tx.recentBlockhash = blockhash;
        tx.feePayer = wallet.publicKey;
        return tx;
      }
      );

      const signedTransactions = await wallet.signAllTransactions(datedStakeSelected);

      await Promise.all(
        (signedTransactions as Transaction[])
          .map((tx) =>
            connection.sendRawTransaction(tx.serialize(), {
              // skipPreflight: false,
              preflightCommitment: "confirmed",
            })
              .then(async (txid) => {
                toast.success("Attempting to Stake NFTs",
                  {
                    id: "stake",
                    duration: Infinity
                  }
                )
                // console.log("txid", txid)
                await connection.confirmTransaction(txid, "confirmed")
                toast.success("Successfully Staked NFTs",
                  {
                    id: "stake",
                    duration: 5000
                  }
                )
                props.fetchNFTs();
                // setValidNFTHeld([...validNFTHeld, ...selectedNFTs])
              })
          ));

      // console.log("stakeTxs", stakeTxs)
    } catch (error) {
      let errorMessage = error?.message ?? error;
      // console.error("Error staking nft", errorMessage)
      toast.error(`Error staking nft ${errorMessage}`, {
        id: "stake",
        duration: 5000
      })
    }
  };

  const handleUnstakeSingle = async () => {
    try {

      toast.success("Generating Unstake Transaction", {
        id: "unstake",
        duration: Infinity
      })

      let unstakeSelected = await unstake(
        connection,
        wallet,
        props.collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? "pool-name-0.1908876937934032" : "pool-name-0.7364440881038641",
        [{
          mintId: new PublicKey(props.nft.mintAddress)
        }],
        [new PublicKey(props.collectionFilter === "3gGZWkqRBPp4s25XfQHxZgUc74ZcutLFFQtJim3yy8ZR" ? "38JuPXo9QpFFnBsvk75a3fScCQSC7f6phtidHpAtQhWr" : "HQw3xmjaPSwNVVPNjstCmj3uFXdpwfzqP9HYqnAqqUdS")],
      )

      const { blockhash } = await connection.getLatestBlockhash();
      const datedUnstakeSelected = unstakeSelected.map((tx) => {
        tx.recentBlockhash = blockhash;
        tx.feePayer = wallet.publicKey;
        return tx;
      });

      const userGobiATA = getAssociatedTokenAddressSync(gobiAddress, wallet.publicKey);
      // console.log("userGobiATA", userGobiATA)
      let isGobiATAOpen = (await connection.getAccountInfo(userGobiATA)) !== null;

      if (!isGobiATAOpen) {
        let createGobiATA = createAssociatedTokenAccountInstruction(
          wallet.publicKey,
          userGobiATA,
          wallet.publicKey,
          gobiAddress,
        )

        const { blockhash } = await connection.getLatestBlockhash();

        const tx = new Transaction().add(createGobiATA);
        tx.recentBlockhash = blockhash;
        tx.feePayer = wallet.publicKey;
        toast.loading("Step 1 of 2: Please create your rewards token account first", {
          id: "unstake",
          duration: Infinity
        })
        await wallet.sendTransaction(tx, connection)
        toast.success("Step 2 of 2: Successfully created your rewards token account, now please approve your unstake transactions.", { id: "unstake", duration: 5000 })
      }


      const signedTransactions = await wallet.signAllTransactions(datedUnstakeSelected);

      await Promise.all(
        (signedTransactions as Transaction[])
          .map((tx) =>
            connection.sendRawTransaction(tx.serialize(), {
              // skipPreflight: false,
              preflightCommitment: "confirmed",
            })
              .then(async (txid) => {
                toast.success("Attempting to unstake NFTs",
                  {
                    id: "unstake",
                    duration: Infinity
                  }
                )
                // console.log("txid", txid)
                await connection.confirmTransaction(txid, "confirmed")
                toast.success("Successfully Unstaked NFTs",
                  {
                    id: "unstake",
                    duration: 5000
                  }
                )
                props.fetchNFTs();
              })
          ));

      // console.log("stakeTxs", stakeTxs)
    } catch (error) {
      let errorMessage = error?.message ?? error;
      // console.error("Error unstaking nft", errorMessage)
      toast.error(`Error unstaking nft ${errorMessage}`, {
        id: "unstake",
        duration: 5000
      })
    }
  };

  return (
    <StyledStakingCard className="stakingCard">
      <div className="stakingCard-image">
        <Image src={props.nft.imageUrl} fill={true} sizes="(min-width: 0) 50vw" alt="Merchant" />
      </div>
      <div className="stakingCard-row">
        <div className="stakingCard-name">
          {props.nft.name.replace("s By Marco Polo", "")}
        </div>
        {/* <div className="stakingCard-name">
          Rank 0
        </div> */}
      </div>
      <div className="stakingCard-button">
        {props.nft.isCurrentlyStaked ? (
          <button onClick={handleUnstakeSingle} className="stakingCard-button--unstake">Unstake</button>
        ) : (
          <button onClick={handleStakeSingle} className="stakingCard-button--stake">Stake</button>
        )}
      </div>

    </StyledStakingCard>
  );

};

export default StakingCard;

const StyledStakingCard = styled.div<{}>`

  position: relative;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: ${color.gray(32)};

  .stakingCard-image{

    position: relative;
    width: 100%;
    border-radius: 0.5rem;
    overflow: clip;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    img{
      position: static !important;
      width: 100%;
      height: auto;
      border-radius: 0.5rem;
      overflow: clip;
    }

  }

  .stakingCard-row{
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;
    padding: 1rem 0;
  }

  .stakingCard-name{
    display: flex;
    align-items: center;

    .stakingCard-title{
      font-weight: 300;
    }

    .stakingCard-id{
      font-weight: 600;
    }

  }

  .stakingCard-button{

    button{
      width: 100%;
      height: 2.25rem;
      padding: 0 1rem;
      font-size: 0.875rem;
      font-weight: 750;
      border-radius: 0.375rem;
      background-color: transparent;
      transition: background-color 0.15s ease-out;
    }

    .stakingCard-button--stake{

      color: black;
      background-color: ${color.gray(80)};

      &:hover{
        background-color: ${color.gray(100)};
      }

    }

    .stakingCard-button--unstake{

      color: white;
      border: solid 1px white;
      background-color: transparent;

      &:hover{
        background-color: ${color.gray(80)};
      }

    }

  }
  

`
